import React, { useContext, useEffect, useState } from 'react';
import Title from 'antd/lib/typography/Title';
import './AppealAnswer.scss';
import { Appeal } from '../../model/Appeal';
import { Button, Typography } from 'antd';
import parse from 'html-react-parser';
import { AppealAnswer as AppealAnswerModel } from '../../model/AppealAnswer';
import { formatDate } from '../../utils/formatter';
import { File } from '../../model/File';
import DocumentBox from '../InfoLabel/DocumentBox/DocumentBox';
import Constants from '../../constants/constants';
import { Context } from '../../index';

interface AppealAnswerProps {
  appealId: number;
  appeal?: Appeal;
}

const AppealAnswer = (props: AppealAnswerProps): JSX.Element => {
  const [appealAnswers, setAppealAnswers] =
    useState<AppealAnswerModel[] | null>(null);
  const [appealAccepted, setAppealAccepted] = useState<boolean>(
    props.appeal?.isAccepted || false
  );
  const { store } = useContext(Context);

  useEffect(() => {
    store.getAppealSolvedAnswer(props.appealId).then((resp) => {
      if (resp && resp.length) {
        setAppealAnswers(resp);
      }
    });
  }, []);

  const handleAppealAccept = () => {
    store.setAppealAccept(props.appealId).then((res) => {
      if (res) {
        setAppealAccepted(true);
      }
    });
  };

  return (
    <div className="appealAnswer">
      {appealAnswers ? (
        <>
          <Title level={3}>Ответ</Title>
          {appealAnswers.map((appealAnswer, index) => (
            <div className="appealAnswer__list" key={index}>
              {appealAnswer.executorText && (
                <div className="appealAnswerRow">
                  <Typography.Paragraph className="appealAnswerRow__title">
                    Ответ:
                  </Typography.Paragraph>
                  <div className="appealAnswerRow__text">
                    {parse(appealAnswer.executorText)}
                  </div>
                </div>
              )}
              <div className="appealAnswerRow">
                <Typography.Paragraph className="appealAnswerRow__title">
                  Дата:
                </Typography.Paragraph>
                <div className="appealAnswerRow__text">
                  {formatDate(appealAnswer.createdAt)}
                </div>
              </div>
              {appealAnswer.holdTo && (
                <div className="appealAnswerRow">
                  <Typography.Paragraph className="appealAnswerRow__title">
                    Дата отложенного решения:
                  </Typography.Paragraph>
                  <div className="appealAnswerRow__text">
                    {formatDate(appealAnswer.holdTo)}
                  </div>
                </div>
              )}
              {appealAnswer?.files?.length > 0 && (
                <div className="appealAnswerRow">
                  <Typography.Paragraph className="appealAnswerRow__title">
                    Прикрепленные файлы:
                  </Typography.Paragraph>
                  <div className="appealAnswerRow__files">
                    {appealAnswer.files.map((file: File) => {
                      return <DocumentBox file={file} key={file.id} />;
                    })}
                  </div>
                </div>
              )}
              {props.appeal && !appealAnswer.holdTo && !appealAccepted && (
                <div className="appealAnswerRow">
                  <Typography.Paragraph className="appealAnswerRow__title" />
                  <div className="appealAnswerRow__text">
                    <Button.Group>
                      <Button
                        type="primary"
                        onClick={() => handleAppealAccept()}
                      >
                        Проблема устранена
                      </Button>
                    </Button.Group>
                  </div>
                </div>
              )}
            </div>
          ))}
        </>
      ) : (
        <>
          {props.appeal &&
            props.appeal.status.code === Constants.statusCodeRejected && (
              <>
                <Title level={3}>{props.appeal.status.name}</Title>
                <div className="appealAnswer__list">
                  <div className="appealAnswerRow">
                    <Typography.Paragraph className="appealAnswerRow__title">
                      Причина отказа:
                    </Typography.Paragraph>
                    <div className="appealAnswerRow__text">
                      {props.appeal.rejectionReason.text}
                    </div>
                  </div>
                  {props.appeal.moderatorComment !== '' && (
                    <div className="appealAnswerRow">
                      <Typography.Paragraph className="appealAnswerRow__title">
                        Комментарий:
                      </Typography.Paragraph>
                      <div className="appealAnswerRow__text">
                        {parse(props.appeal.moderatorComment)}
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
        </>
      )}
    </div>
  );
};

export default AppealAnswer;
